import { Component, Input, ViewEncapsulation } from '@angular/core';
import { EqBaseComponent } from '../eq-base/eq-base.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
const Material = [
  MatFormFieldModule,
  MatRippleModule,
  MatIconModule,
  MatSelectModule,
];
@Component({
  selector: 'eq-dropdown-disabled-options',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...Material
  ],
  templateUrl: './dropdownDisabledOptions.component.html',
  styleUrl: './dropdownDisabledOptions.component.scss',
  encapsulation: ViewEncapsulation.None

})
export class DropdownDisabledOptionsComponent extends EqBaseComponent {
  @Input() options = [
    { label: "Default", value: "default", disabled: false},
  ]
  @Input() multiSelect: boolean = false;
}
